module.exports = __webpack_public_path__ + "img/logo-vert.ca4848f2.jpg";